import { Box, Button, Collapse, Dialog, DialogContent, Grid, Typography } from "@mui/material"
import Thumb from "../../../assets/img/logo with description.svg"
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import { ISumulator } from "../../../utils/@interfaces"
import { ClientsService } from "../../../services/clients"
import { Constants, Format } from "../../../utils"
import moment from "moment"
import { usePageTitle } from "../../../hooks"
import { CCarousel, CCarouselItem, CImage } from '@coreui/react'

import Carrousel1 from "../../../assets/img/hotItWorks/1.jpeg"
import Carrousel2 from "../../../assets/img/hotItWorks/2.jpeg"
import Carrousel3 from "../../../assets/img/hotItWorks/3.jpeg"
import Carrousel4 from "../../../assets/img/hotItWorks/4.jpeg"
import Carrousel5 from "../../../assets/img/hotItWorks/5.jpeg"


export const HowItWorks = () => {
    usePageTitle("Como funciona")
    const navigate = useNavigate()
    const { state } = useLocation()

    const videoRef = useRef<HTMLVideoElement | null>(null);

    const [data, setData] = useState<null | ISumulator>(null)

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.load();
        }
        getSimulation(Constants.creditEvolution[0])
    }, []);

    useEffect(() => {
        // importação do estilos do carousel
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@coreui/coreui/dist/css/coreui.min.css';
        link.id = 'coreui-styles'; // ID para facilitar a remoção

        document.head.appendChild(link); // Adiciona o CSS ao <head>

        return () => {
            // remoção dos estilos do carousel que está dando conflito com o restante do site
            const existingLink = document.getElementById('coreui-styles');
            if (existingLink) {
                existingLink.remove();
            }
        };
    }, []);

    const getSimulation = (value: number) => {
        ClientsService.simulator(value)
            .then(({ data }) => {
                setData(data)
                console.log(data)
            })
    }

    const handlePlay = () => {
        const video = videoRef.current;

        if (video) {
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if ((video as any).webkitEnterFullscreen) {
                (video as any).webkitEnterFullscreen();
            } else if ((video as any).msRequestFullscreen) {
                (video as any).msRequestFullscreen();
            }
        }
    };

    return (
        <Dialog open fullScreen >
            <DialogContent sx={{
                backgroundColor: "rgba(237, 238, 254, 1)"
            }}>
                <Grid display={"flex"} direction={"column"} gap={"2rem"} pt={"3rem"}>

                    <Typography fontSize={"2rem"} fontWeight={600} mt={"2rem"} p={0}>Assista o video</Typography>

                    <video ref={videoRef} controls controlsList="nodownload" preload="auto" poster={Thumb} onPlay={handlePlay} style={{
                        maxWidth: '100%',
                        borderRadius: "20px"
                    }}>
                        <source src={"https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/GYROO+-+COMO+FUNCIONA.mp4"} type="video/mp4" />
                    </video>

                    <Button
                        variant="contained"
                        onClick={() => {
                            navigate("/enquete" + window.location.search, {
                                state: {
                                    verified: true,
                                    checkCep: false
                                }
                            })
                        }}
                        sx={{
                            width: "100%",
                            animation: "pulse 2s infinite",
                            background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",

                        }}
                    >Solicite seu crédito aqui</Button>

                    {state?.from !== "simulator" &&
                        <>
                            <Typography fontSize={"2rem"} fontWeight={600} mt={"2rem"} p={0}>Simulação</Typography>

                            <Grid
                                sx={{
                                    background: "linear-gradient(90deg, #1D22E6 0%, #01E7FE 100%)",
                                    width: `calc(100% + 4.5rem)`,
                                    ml: `-2.26rem`,
                                    padding: "1rem 1rem",
                                    boxSizing: "border-box",
                                    mt: "1rem"
                                }}
                            >
                                <Typography textAlign={"center"} fontSize={"1.8rem"} color="#FFFFFF">
                                    Valor que você receberá em <strong>PIX NA HORA</strong>
                                </Typography>

                                <Typography textAlign={"center"} fontSize={"4rem"} color="#FFFFFF" fontWeight={800}>
                                    {Format.currency(Constants.creditEvolution[0])}
                                </Typography>
                            </Grid>

                            <Typography color="warning" fontSize={"1.4rem"} textAlign={"center"}>O valor das diárias diminuem a cada dia <span style={{ fontSize: "2rem" }}>&#129295;</span></Typography>
                            <Collapse in={!!data}>
                                <Grid
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: ".3rem",
                                        mt: "-1rem"
                                    }}
                                >
                                    <Grid
                                        key={"parcel-header"}
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "nowrap",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            boxSizing: "border-box",
                                            backgroundColor: "rgba(255, 255, 255, 1)",
                                            borderRadius: "10px",
                                            minHeight: "3.7rem",
                                            padding: ".3rem 1rem",
                                            border: "0.5px solid #00000040"
                                        }}
                                    >
                                        <Typography fontSize={"1.6rem"} fontWeight={600}>Diárias</Typography>
                                        <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5, ml: "-3rem" }} textAlign={"center"}>Vencimento</Typography>
                                        <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">Valor</Typography>
                                    </Grid>
                                    {data?.parcels?.map((parcel) => {
                                        return (
                                            <Grid
                                                key={"parcel" + parcel.index}
                                                sx={{
                                                    width: "100%",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    flexWrap: "nowrap",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    boxSizing: "border-box",
                                                    backgroundColor: "rgba(255, 255, 255, 1)",
                                                    borderRadius: "10px",
                                                    minHeight: "3.7rem",
                                                    padding: ".3rem 1rem",
                                                    border: "0.5px solid #00000040"
                                                }}
                                            >
                                                <Typography fontSize={"1.6rem"} fontWeight={600}>{parcel.index} de 24</Typography>
                                                <Typography fontSize={"1.2rem"} fontWeight={400} sx={{ opacity: 0.5 }} textAlign={"center"}>Venc.: {moment(parcel.date).format("DD/MM/YY")}<br />{moment(parcel.date).format("[(]dddd[)]")}</Typography>
                                                <Typography fontSize={"1.6rem"} fontWeight={700} color="secondary">{Format.currency(parcel.totalToPay)}</Typography>

                                            </Grid>
                                        )
                                    })}

                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            navigate("/enquete" + window.location.search, {
                                                state: {
                                                    verified: true,
                                                    checkCep: false
                                                }
                                            })
                                        }}
                                        sx={{
                                            mt: "1rem",
                                            width: "100%",
                                            animation: "pulse 2s infinite",
                                            background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",

                                        }}
                                    >Solicite seu crédito aqui</Button>
                                </Grid>
                            </Collapse>
                        </>
                    }


                    <Typography fontSize={"2rem"} fontWeight={600} mt={"2rem"} p={0}>Como funciona?</Typography>

                    <CCarousel controls indicators transition="slide" style={{
                        width: "100%"
                    }}>
                        <CCarouselItem>
                            <CImage style={{
                                display: "block",
                                width: "100%"
                            }} src={Carrousel1} alt="slide 1" />
                        </CCarouselItem>
                        <CCarouselItem>
                            <CImage style={{
                                display: "block",
                                width: "100%"
                            }} src={Carrousel2} alt="slide 2" />
                        </CCarouselItem>
                        <CCarouselItem>
                            <CImage style={{
                                display: "block",
                                width: "100%"
                            }} src={Carrousel3} alt="slide 3" />
                        </CCarouselItem>
                        <CCarouselItem>
                            <CImage style={{
                                display: "block",
                                width: "100%"
                            }} src={Carrousel4} alt="slide 4" />
                        </CCarouselItem>
                        <CCarouselItem>
                            <CImage style={{
                                display: "block",
                                width: "100%"
                            }} src={Carrousel5} alt="slide 5" />
                        </CCarouselItem>

                    </CCarousel>

                    <Button
                        variant="contained"
                        onClick={() => {
                            navigate("/pix" + window.location.search, {
                                state: {
                                    verified: true
                                }
                            })
                        }}
                        sx={{
                            width: "100%",
                            // animation: "pulse 2s infinite",
                            background: "linear-gradient(90deg, #178BF1 24.4%, #1D22E6 100%)",

                        }}
                    >Conheça nosso site</Button>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}